import { Box } from 'reflexbox';
import styled from 'styled-components';

import { palettes, tokens } from '../theme/tokens';

const defaultTint = {
	text: palettes.heatherGray['900'],
	background: palettes.heatherGray['50'],
	border: palettes.heatherGray['300'],
	icon: palettes.heatherGray['900'],
};

const tintStyle = (tint?: string) => {
	if (!tint) {
		return defaultTint;
	}

	if (tint === 'primary' || tint === 'info' || tint === 'blue' || tint === 'lightBlue') {
		return tokens.info;
	}

	if (tint === 'success' || tint === 'green') {
		return tokens.success;
	}

	if (tint === 'danger' || tint === 'error' || tint === 'red') {
		return tokens.error;
	}

	if (tint === 'warning' || tint === 'yellow' || tint === 'orange') {
		return tokens.warning;
	}

	if (tint === 'purple') {
		return {
			text: tokens.brand.text,
			background: tokens.brand.background,
			border: tokens.brand.border,
			icon: tokens.brand.text,
		};
	}

	return defaultTint;
};

const Pill = styled(Box)<{ tint?: string; small?: boolean }>`
	display: inline-flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: max-content;
	max-width: 100%;
	height: 30px;
	box-sizing: border-box;
	gap: ${tokens.gap.inline}px;
	white-space: nowrap;
	padding: ${tokens.gap.inline}px ${tokens.padding.compact}px;
	border-radius: ${tokens.radius.full}px;
	border: 1px solid ${(props) => tintStyle(props.tint).border};
	background-color: ${(props) => tintStyle(props.tint).background};
	color: ${(props) => tintStyle(props.tint).text};
	font-family: ${tokens.typography.fontFamily};
	font-weight: ${tokens.typography.weights.medium};
	font-size: ${tokens.typography.sizes.small}px;
	line-height: 1.5;
	letter-spacing: 0.13px;
	vertical-align: middle;

	svg {
		display: block;
		width: 16px;
		height: 16px;
		flex-shrink: 0;
		color: ${(props) => tintStyle(props.tint).icon ?? tintStyle(props.tint).text};
	}
`;

export { Pill };
